<script setup>
/**
 * FormPageContentField
 * Fetches and displays a Content record's title and its associated type label.
 * Primarily used within lists or forms to reference linked content blocks.
 */
import {ref, watch} from 'vue'
import {useItemDataStore} from '@/stores/itemData'
import ContentTypeLabel from '@/common/ContentTypeLabel.vue'

const props = defineProps({
    contentId: {
        type: Number,
        required: true
    }
})

const itemDataStore = useItemDataStore()

// Reactive reference to store the asynchronously fetched content item
const content = ref(null)

// Watch contentId prop changes and asynchronously fetch item data
watch(() => props.contentId, async (newId) => {
    if (newId) {
        content.value = await itemDataStore.get({
            tableName: 'content',
            id: newId
        })
    } else {
        content.value = null
    }
}, {immediate: true})
</script>

<template>
    <span>
        {{ content?.title }}
        <ContentTypeLabel
            v-if="content"
            :content-type-id="content.contentType"
            class="ms-1"
        />
    </span>
</template>